module.exports = __webpack_public_path__ + "static/media/universe_blue.76b5edcc.png";